import React from "react";
import { Alert, Button, Popconfirm, Space } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  deleteAlbumById,
  getAlbum,
  selectAlbum,
  toggleAlbumById,
} from "../../store/slices/albumSlice";
import AddAlbumPopup from "./AddAlbumPopup";
import MediaUpload from "./MediaUpload";

const AlbumShow = () => {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [publishLoading, setPublishLoading] = useState(false);

  const { id } = useParams();
  const history = useHistory();

  const album = useSelector(selectAlbum);
  const dispatch = useDispatch();

  const fetchData = () => {
    setLoading(true);
    dispatch(
      getAlbum(id, (data) => {
        setLoading(false);
      })
    );
  };

  useEffect(() => {
    fetchData(id);
  }, []);

  const handleDelete = (item) => {
    setDeleteLoading(true);
    dispatch(
      deleteAlbumById(item.id, () => {
        setDeleteLoading(false);
        history.push("/gallery");
      })
    );
  };

  const changeStatus = (item) => {
    setPublishLoading(true);
    dispatch(
      toggleAlbumById(item.id, () => {
        setPublishLoading(false);
      })
    );
  };

  if (loading || !album) {
    return (
      <div className="page-wrapper">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <Space
        direction="horizontal"
        style={{
          width: "100%",
          justifyContent: "space-between",
          marginBottom: "1rem",
        }}
        wrap
      >
        <div
          style={{
            marginBottom: "1rem",
          }}
        >
          <h2 style={{ fontWeight: "bold" }}>{album.title}</h2>
          <Alert
            message={
              album.isPublished
                ? "The album is published to www."
                : "The album is not published to www."
            }
            type={album.isPublished ? "success" : "warning"}
            action={
              <Space>
                <Popconfirm
                  deleteLoading={publishLoading}
                  title={
                    album.isPublished
                      ? "Are you sure want to unpublish this album?"
                      : "Are you sure want to publish this album?"
                  }
                  onConfirm={() => changeStatus(album)}
                >
                  <Button style={{ width: "100px" }} danger={album.isPublished}>
                    {album.isPublished ? "Unpublish" : "Publish"}
                  </Button>
                </Popconfirm>
              </Space>
            }
          />
        </div>

        <Space
          style={{
            width: "100%",
            marginBottom: "15px",
            justifyContent: "flex-end",
          }}
          size={10}
          direction="horizontal"
          align="end"
        >
          <Popconfirm
            deleteLoading={deleteLoading}
            title="Are you sure want to delete this album?"
            onConfirm={() => handleDelete(album)}
          >
            <Button type="danger">Delete Album</Button>
          </Popconfirm>

          <Button
            type="primary"
            onClick={() => {
              setIsModalVisible(true);
            }}
          >
            Edit Info
          </Button>
        </Space>
      </Space>

      <section style={{ marginBottom: "3rem" }}>
        <h3 style={{ fontWeight: "bold" }}>Description</h3>
        <p>{album.description}</p>
      </section>

      <section style={{ marginBottom: "3rem" }}>
        <h3 style={{ fontWeight: "bold" }}>Photos</h3>
        <Alert
          message="Recommended image size: max 1MB."
          type="warning"
          style={{ marginTop: "4px", marginBottom: "16px" }}
        ></Alert>
        <MediaUpload album={album}></MediaUpload>
      </section>

      {isModalVisible && (
        <AddAlbumPopup closePopup={setIsModalVisible} item={album} />
      )}
    </div>
  );
};

export default AlbumShow;
